/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateSupplierRequest,
  GetSupplierParams,
  ListSuppliersParams,
  PaginatedSupplierDto,
  SupplierDto,
  SupplierId,
  UpdateSupplierRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListSuppliersUrl = (params: ListSuppliersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/suppliers?${stringifiedParams}`
    : `/api/v1/engineering/suppliers`;
};

/**
 * @summary List suppliers
 */
export const listSuppliers = async (
  params: ListSuppliersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedSupplierDto> => {
  return customFetch<PaginatedSupplierDto>(getListSuppliersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateSupplierUrl = () => {
  return `/api/v1/engineering/suppliers`;
};

/**
 * @summary Create supplier
 */
export const createSupplier = async (
  createSupplierRequest: CreateSupplierRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierId> => {
  return customFetch<SupplierId>(getCreateSupplierUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createSupplierRequest),
  });
};

export const getGetSupplierUrl = (id: SupplierId, params?: GetSupplierParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/suppliers/${id}?${stringifiedParams}`
    : `/api/v1/engineering/suppliers/${id}`;
};

/**
 * @summary Get supplier
 */
export const getSupplier = async (
  id: SupplierId,
  params?: GetSupplierParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierDto> => {
  return customFetch<SupplierDto>(getGetSupplierUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateSupplierUrl = (id: SupplierId) => {
  return `/api/v1/engineering/suppliers/${id}`;
};

/**
 * @summary Update supplier
 */
export const updateSupplier = async (
  id: SupplierId,
  updateSupplierRequest: UpdateSupplierRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateSupplierUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateSupplierRequest),
  });
};

export const getDeleteSupplierUrl = (id: SupplierId) => {
  return `/api/v1/engineering/suppliers/${id}`;
};

/**
 * @summary Delete supplier
 */
export const deleteSupplier = async (
  id: SupplierId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreSupplierUrl = (id: SupplierId) => {
  return `/api/v1/engineering/suppliers/${id}/restore`;
};

/**
 * @summary Restore supplier
 */
export const restoreSupplier = async (
  id: SupplierId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreSupplierUrl(id), {
    ...options,
    method: "POST",
  });
};
